module.exports = __webpack_public_path__ + "img/icon-zip.54c6aa0f.svg";